<template>
    <div>
        <GmapMap
            :center="center"
            :options="options"
            :zoom="11"
            style="width: 100%; max-width: 100%; height: 350px"
        >
            <GmapMarker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                :clickable="true"
                :draggable="true"
                @click="center=m.position"
                :label="m.label"
            />
        </GmapMap>
    </div>
</template>
<script>
export default {
    props: {
        checkpoints: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        options: {
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: true,
            disableDefaultUi: false
        },
        center: {
            lat: 0,
            lng: 0
        }
    }),
    computed: {
        markers() {
            return this.checkpoints.sort((a, b) => a.created_at - b.created_at).map((chp, i) => ({ id: chp.id, position: { lat: parseFloat(chp.latitude), lng: parseFloat(chp.longitude) }, label: (i + 1) + '' }));
        }
    },
    methods: {
        geolocate() {
            if(navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }
                })
            }
        },
        setCenter() {
            if(this.markers.length > 0) {
                this.center = this.markers[0].position;
            } else {
                this.geolocate();
            }
        },
        initialize() {
            this.setCenter();
        }
    },
    created() {
        this.initialize();
    }
}
</script>
